
(function () {
  function init(root) {
    if (root.dataset.ngstlInitialized === 'true') return;
    root.dataset.ngstlInitialized = 'true';

    const looks = Array.from(
      root.querySelectorAll('[data-ngstl-look]')
    );

    function close(look) {
      look.classList.remove('is-open');

      const openButton = look.querySelector('[data-ngstl-open]');
      const panel = look.querySelector('[data-ngstl-panel]');

      openButton.setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'true');
      panel.inert = true;
    }

    function open(look) {
      looks.forEach(other => {
        if (other !== look) close(other);
      });

      const openButton = look.querySelector('[data-ngstl-open]');
      const panel = look.querySelector('[data-ngstl-panel]');

      look.classList.add('is-open');
      openButton.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');
      panel.inert = false;

      panel.querySelector('[data-ngstl-close]').focus({
        preventScroll: true
      });
    }

    root.addEventListener('click', async function (event) {
      const openButton = event.target.closest('[data-ngstl-open]');

      if (openButton && root.contains(openButton)) {
        open(openButton.closest('[data-ngstl-look]'));
        return;
      }

      const closeButton = event.target.closest('[data-ngstl-close]');

      if (closeButton && root.contains(closeButton)) {
        const look = closeButton.closest('[data-ngstl-look]');

        close(look);

        look.querySelector('[data-ngstl-open]').focus({
          preventScroll: true
        });

        return;
      }

      const addButton = event.target.closest('[data-ngstl-add]');

      if (
        !addButton ||
        !root.contains(addButton) ||
        addButton.disabled
      ) return;

      const product = addButton.closest('[data-ngstl-product]');
      const variantControl = product.querySelector('[data-ngstl-variant]');
      const message = product.querySelector('[data-ngstl-message]');
      const variantId = variantControl.value;

      message.classList.remove('is-error');

      if (!variantId) {
        message.textContent = 'Please select a size / variant.';
        message.classList.add('is-error');
        variantControl.focus();
        return;
      }

      addButton.disabled = true;
      addButton.textContent = 'Adding...';

      try {
        const base = (
          window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root
        ) || '/';

        const response = await fetch(base + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: Number(variantId),
              quantity: 1
            }]
          })
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(
            result.description ||
            result.message ||
            'Could not add to cart.'
          );
        }

        addButton.textContent = 'Added';
        message.textContent = 'Added to your cart.';

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true
          })
        );

        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            detail: { item: result }
          })
        );

      } catch (error) {
        message.textContent =
          error.message || 'Could not add to cart.';

        message.classList.add('is-error');

      } finally {
        setTimeout(function () {
          addButton.disabled = false;
          addButton.textContent = 'Add to cart';
        }, 1200);
      }
    });

    
    // NGSeven - Size button selection

    root.addEventListener('click', function (event) {
      const sizeButton = event.target.closest(
        '[data-ngstl-size-option]'
      );

      if (
        !sizeButton ||
        !root.contains(sizeButton) ||
        sizeButton.disabled
      ) return;

      const picker = sizeButton.closest(
        '[data-ngstl-size-picker]'
      );

      // Remove previous selection
      picker.querySelectorAll('[data-ngstl-size-option]')
        .forEach(function (button) {
          button.classList.remove('is-selected');
          button.setAttribute('aria-pressed', 'false');
        });

      // Mark selected size
      sizeButton.classList.add('is-selected');
      sizeButton.setAttribute('aria-pressed', 'true');

      // Show selected size in label
      picker.querySelector('[data-ngstl-selected-size]')
        .textContent = sizeButton.textContent.trim();

      // Update Shopify variant ID
      picker.querySelector('[data-ngstl-variant]')
        .value = sizeButton.dataset.variantId;

      const product = picker.closest('[data-ngstl-product]');
      const price = product.querySelector('[data-ngstl-price]');
      const message = product.querySelector('[data-ngstl-message]');

      // Update displayed price
      if (sizeButton.dataset.price) {
        price.textContent = sizeButton.dataset.price;
      }

      // Clear previous messages
      message.textContent = '';
      message.classList.remove('is-error');
    });


    root.addEventListener('change', function (event) {
      const select = event.target.closest(
        'select[data-ngstl-variant]'
      );

      if (!select || !root.contains(select)) return;

      const product = select.closest('[data-ngstl-product]');
      const price = product.querySelector('[data-ngstl-price]');
      const option = select.selectedOptions[0];

      if (option && option.dataset.price) {
        price.textContent = option.dataset.price;
      }

      const message = product.querySelector('[data-ngstl-message]');
      message.textContent = '';
      message.classList.remove('is-error');
    });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        const look = root.querySelector('.ngstl__look.is-open');

        if (look) {
          close(look);
          look.querySelector('[data-ngstl-open]').focus({
            preventScroll: true
          });
        }
      }
    });
  }

  function initialize(scope) {
    if (scope.matches && scope.matches('[data-ngstl]')) {
      init(scope);
    }

    scope.querySelectorAll('[data-ngstl]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialize(document);
    });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
